namespace SP {
    export interface PickListInfo {
        pickListId: number;
        pickListActive: boolean;
        pickListGrouped: boolean;
        pickListAttention: boolean;
        pickListRouteLength: number;
        pickListDate: string;
        pickListTime: string;
        pickListTimestamp: number;
        pickLinesCount: number;
        pickCount: number;
        pickedCount: number;
        picked: boolean;
        customerId: string;
        stockName: string;
        createUserName: string;
        occupantUserName: string;
        allowLocationScanPicking: number;
        pickSettings: PickSettingInfo;
        trolley: TrolleyInfo;
        productionOrders: OrderInfo[];
    }
}